import React, {useEffect, useState, useRef} from "react";
import {
  type CropperBackgroundWrapperProps,
  TransformableImage,
  useMoveImageOptions,
  useScaleImageOptions,
} from "react-advanced-cropper";

import _ from "lodash";

interface ExtendedProps extends CropperBackgroundWrapperProps {
  enableWheelHint?: boolean;
}

export const BackgroundWrapperNoWheelZoom = ({
                                               cropper,
                                               scaleImage = true,
                                               moveImage = true,
                                               children,
                                               className,
                                               style,
                                               enableWheelHint = false
                                             }: ExtendedProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [isShiftPressed, setIsShiftPressed] = useState(false);
  const moveImageOptions = useMoveImageOptions(moveImage);
  const scaleImageOptions = useScaleImageOptions(scaleImage);
  const transitions = cropper.getTransitions();

  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === "Shift") setIsShiftPressed(true);
    };

    const up = (e: KeyboardEvent) => {
      if (e.key === "Shift") setIsShiftPressed(false);
    };

    window.addEventListener("keydown", down);
    window.addEventListener("keyup", up);

    return () => {
      window.removeEventListener("keydown", down);
      window.removeEventListener("keyup", up);
    };
  }, []);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const handleWheel = (e: WheelEvent) => {
      if (!enableWheelHint) return;
      if (!e.shiftKey) {
        _.toastInfo("Use Shift + Mouse Wheel to zoom");
      }
    };

    el.addEventListener("wheel", handleWheel, { passive: true });

    return () => {
      el.removeEventListener("wheel", handleWheel);
    };
  }, [enableWheelHint]);

  return (
    <div ref={containerRef} className="w-full h-full">
      <TransformableImage
        className={className}
        style={style}
        onTransform={cropper.transformImage}
        onTransformEnd={cropper.transformImageEnd}
        touchMove={moveImageOptions.touch}
        mouseMove={moveImageOptions.mouse}
        touchScale={scaleImageOptions.touch}
        wheelScale={isShiftPressed ? scaleImageOptions.wheel : false}
        disabled={transitions.active}
      >
        {children}
      </TransformableImage>
    </div>
  );
};